import { server } from 'config/environment'
import { makeAutoObservable } from 'mobx'
import { WindowUiStore } from 'store/home/ui/WindowUiStore'

export class HomeUiStore {
  readonly window = new WindowUiStore()

  constructor() {
    makeAutoObservable(this)
    if (server) return
  }

  setUserAgent(userAgent: string | undefined) {
    this.window.init(userAgent)
  }
}

export const ui = new HomeUiStore()
